import AbstractAlGuestlistEditorPagesController from '../../abstracts/abstract-page-controller';

export default class AlGuestlistEditorPageOnlineCheckinComponentController extends AbstractAlGuestlistEditorPagesController {

    constructor($injector, $scope) {
        super($injector, $scope);

        this.modelPrepared = false;
    }

    // Internal functions
    _initWatchers() {
        super._initWatchers();
    }

    _fillModelFromGuestlist() {
        this.model = {
            settings: {
                enable_online_checkin: this.getGuestlistValue('settings.enable_online_checkin'),
                online_checkin_settings: this.getGuestlistValue('settings.online_checkin_settings')
            }
        };

        this.injector.get('$timeout')(() => {
            this.modelPrepared = true;
        }, 0);
    }

    _initFormConfig() {}
}



// WEBPACK FOOTER //
// ./src/app/modules/guestlists/components/al-guestlist-editor/pages/online-checkin/controller.js